import { combineReducers } from 'redux'

import stepBar from './stepbar/stepbar-reducer'

const reducerMap = {
  stepBar,
}

export default combineReducers(reducerMap)
